/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

// Listener for Free Shipping Bar in Notification Pop Up
document.addEventListener('DOMContentLoaded', () => {
  const cartPopup = document.getElementById('popup-cart-notification');
  if (!cartPopup) return;

  cartPopup.addEventListener('on:popup:opened', () => {
    cartPopup.dispatchEvent(new CustomEvent('on:modal:opened', { bubbles: false }));
  });

  cartPopup.addEventListener('on:popup:closed', () => {
    cartPopup.dispatchEvent(new CustomEvent('on:modal:closed', { bubbles: false }));
  });
});